module.exports = __webpack_public_path__ + "./img/logo_large.d31cc84f624bad16c4a56b64fee11a60.png";


//////////////////
// WEBPACK FOOTER
// ./public/img/logo_large.png
// module id = ./public/img/logo_large.png
// module chunks = 0